import React from "react";
const {Helmet} = require("react-helmet");
import { graphql } from "gatsby";
import {MoreArticles} from "../components/moreArticles/moreArticles";
import {StrapiLayout} from "@klear/open-site";
import {footerData} from "../components/footerData";


export default ({ data }) => {
    const allPosts = data.allPosts.edges;

    return (
        <StrapiLayout footerProps={footerData}>
            <div >
                <Helmet>
                    <title>Blog | Klear</title>
                    <meta name="description" content="Influencer marketing news, data, and tips from industry experts." />
                </Helmet>
                {allPosts.length > 0 &&
                <MoreArticles
                    mainTitle={"All blog posts"}
                    posts={allPosts}
                    isCategoryPage={true}
                />
                }
            </div>
        </StrapiLayout>
    );
};
export const pageQuery = graphql`
  query{
    allPosts: allWordpressPost(sort: {fields: date, order: DESC}, limit: 100 ) {
    edges {
          node {
            date(formatString: "MMMM DD, YYYY")
            title
            content
            slug
            excerpt
            featured_media {
              source_url
            }
            author {
              name
            }
            categories {
              name
              slug
            }
          }
        }
    }
  }
`;